module.exports = __webpack_public_path__ + "img/petrovskiy.8cc75ea9.jpg";